import axios from 'axios';
import Cookies from 'js-cookie';
import { editUserDataAction } from './EditUserDataSlice';

const editUserData = (displayName, username) => {
  const auth = `Bearer ${Cookies.get('auth_token')}`;
  return async (dispatch) => {
    const fetchData = async () => {
      const body = { displayName: displayName, username:username, language: 'en' };
      const url = `${process.env.REACT_APP_DEV_URI}/user/me/edit`;
      const headers = {
        'Content-Type': 'application/json',
        Authorization: auth,
      };
      const response = await axios.post(url, body, { headers });
      return response;
    };
    try {
      const editedData = await fetchData();
      return dispatch(editUserDataAction.editUserDataHandler({ editedData }));
    } catch (e) {
      if (e.response.status === 401) {
        Cookies.remove('auth_token');
        Cookies.remove('refresh_token');
        window.location.pathname = '/';
        window.history.pushState(null, document.title, window.location.href);
      }
      return e;
    }
  };
};

export default editUserData;
